import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { WeatherWindow } from 'types';

export const getWeatherWindow = async (
  windowId: number
): Promise<WeatherWindow | undefined> => {
  const { data } = await axios.get(`/api/weather/windows/${windowId}`);
  return data as WeatherWindow | undefined;
};

type QueryFnType = typeof getWeatherWindow;

type UseWeatherWindowOptions = {
  windowId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useWeatherWindow = ({
  windowId,
  config,
}: UseWeatherWindowOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['weatherWindows', windowId],
    queryFn: () => getWeatherWindow(windowId),
  });
};
